import { SelectionChange } from '@angular/cdk/collections';

export type TableSelectionChange<T> = Omit<SelectionChange<T>, 'source'> & { selected: T[] };
